export default __webpack_public_path__ + "static/media/AT-2020-16-7.0222146c.png";